import { useMixpanelTrackers } from "@jidlomat/terminal-core/hooks/useMixpanelTrackers";
import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MaintenanceAnimation } from "./MaintenanceAnimation";

const StartingUpModalContent = ({ tracked }: { tracked: boolean }) => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const { trackStartingUpModal } = useMixpanelTrackers();
	const trackRef = useRef(trackStartingUpModal);
	trackRef.current = trackStartingUpModal;

	useEffect(() => {
		if (!tracked) {
			return;
		}
		trackRef.current("open");
		logToSentry(`Starting up modal displayed on fridge: ${fridgeId}`, "info");
		return () => {
			trackRef.current("close");
		};
	}, [fridgeId, tracked]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.startingUpModal.title")}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.startingUpModal.description")}
			</Typography>
			<MaintenanceAnimation />
		</ModalContentWrapper>
	);
};

/**
 * `tracked` is false while the screen only bridges the moment between the initial state and the
 * arrival of the flow: the fridge has started by then, so it is neither reported nor logged.
 */
export const StartingUpModal = ({ tracked = true }: { tracked?: boolean }) => (
	<BasicModal
		modalContent={<StartingUpModalContent tracked={tracked} />}
		open={true}
		closable={false}
		fullHeight={true}
	/>
);
